import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CompanyWatchlistTableContent } from '../../models/watchlist-company.model';
import { ItemViewContainerComponent } from '@shared/components/item-view-container.component';

@Component({
  selector: 'app-company-detail-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, ItemViewContainerComponent],
  template: `
    <h2 mat-dialog-title>Company Details</h2>

    <mat-dialog-content>
      <div class="detail-row">
        <app-item-view-container label="Company Name" class="detail-2-item">
          {{ data.companyName }}
        </app-item-view-container>

        <app-item-view-container label="HQ Location" class="detail-item">
          {{ data.hq }}
        </app-item-view-container>
      </div>

      <app-item-view-container label="Sector Scores">
        @for (sector of sectors; track sector) {
          <div class="detail-chip">{{ sector }}</div>
        }
      </app-item-view-container>

      <app-item-view-container label="Controversy List">
        @for (controversy of data.controversy; track controversy) {
          <div class="detail-chip">{{ controversy }}</div>
        }
      </app-item-view-container>

      <app-item-view-container label="Comment">
        {{ data.comment }}
      </app-item-view-container>

      <app-item-view-container label="Advice">
        {{ data.advice }}
      </app-item-view-container>

      <div class="detail-row">
        <app-item-view-container label="Last Reviewed" class="detail-item">
          {{ data.updatedDate }}
        </app-item-view-container>

        <app-item-view-container label="Valid From" class="detail-item">
          {{ data.validFrom }}
        </app-item-view-container>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button mat-dialog-close cdkFocusInitial>Close</button>
    </mat-dialog-actions>
  `,
  styles: `
    .detail-row {
      display: flex;
      gap: 16px;
    }

    .detail-2-item {
      flex: 2;
      min-width: 0;
    }

    .detail-item {
      flex: 1;
      min-width: 0;
    }

    .detail-chip {
      display: inline-block;
      padding: 0.25rem 0.75rem;
      margin: 0.25rem;
      border: 1px solid var(--text-80-color);
      border-radius: 8px;
    }

    mat-dialog-content {
      min-width: 500px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyDetailDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<CompanyDetailDialogComponent>);
  readonly data = inject<CompanyWatchlistTableContent>(MAT_DIALOG_DATA);

  sectors!: string[];

  ngOnInit(): void {
    this.sectors = this.data.sectorScores ? Object.entries(this.data.sectorScores).map(([key, value]) => `${key}: (${value})`) : [];
  }
}
